import script from "./score-item-quantity.vue?vue&type=script&lang=ts&setup=true"
export * from "./score-item-quantity.vue?vue&type=script&lang=ts&setup=true"

import "./score-item-quantity.vue?vue&type=style&index=0&id=34bc00c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bc00c8"]])

export default __exports__